import { Note } from '@eigtech/notes-types'
import { DateTime, formatStringAsDate } from '@eigtech/ui-shared-dates'
import { useMemo } from 'react'
import { sortNotesByDate } from '../utils/sortNotesByDate'

export type UseGroupNotesByDateProps = {
  notes: Note[]
  formatDate?: (date: DateTime, format: string) => string
  isAscending?: boolean
}

export function useGroupNotesByDate(props: UseGroupNotesByDateProps) {
  return useMemo(() => {
    const { notes, isAscending, formatDate } = props

    const normalizeNotes = sortNotesByDate(notes, isAscending)

    const formatter = formatDate ?? formatStringAsDate
    const notesGroupedByDate = normalizeNotes.reduce((accumulator, current) => {
      const date = formatter(current.createdOn, 'MMM dd, yyyy')

      const notesForDate = accumulator.get(date)

      const updatedNotes = notesForDate ? [...notesForDate, current] : [current]
      accumulator.set(date, updatedNotes)

      return accumulator
    }, new Map<string, typeof normalizeNotes>())

    return Array.from(notesGroupedByDate)
  }, [props])
}
